import Mustache from 'mustache'

import { CategoryDictionary, CategorySub, Hierarchy } from '@karakuri-web/faq-type'

import { traverse } from './breadcrumbs'

interface AnswerTitleSetting {
  headerTitleType?: string | null
  words?: {
    answer?: {
      title?: string | null
    } | null
  } | null
}

/**
 * 回答ページのヘッダータイトルを決定する
 */
export function pickAnswerHeaderTitle(
  setting?: AnswerTitleSetting | null,
  parentTitle?: string | null,
  title?: string | null,
  hierarchies?: Hierarchy[]
): string {
  const titleTemplate = setting?.words?.answer?.title
  if (titleTemplate) {
    return Mustache.render(titleTemplate, { title })
  }

  if (setting?.headerTitleType === 'question') {
    const h = hierarchies || []
    const last = h.length > 0 ? h[h.length - 1] : undefined
    if (last?.link.indexOf('/answer') === 0) {
      return title || ''
    }
  }

  return parentTitle || title || ''
}

/**
 * カテゴリページ用パンくずの階層を生成する
 */
export function resolveTagHierarchies(
  stateHierarchies: Hierarchy[] | undefined,
  category: CategorySub | undefined,
  dictionary: CategoryDictionary
): Hierarchy[] {
  if (stateHierarchies) {
    return stateHierarchies
  }
  if (!category) {
    return []
  }

  return traverse(category, dictionary)
    .reverse()
    .reduce<Hierarchy[]>((acc, hierarchy) => {
      acc.push({
        link: `/category/${hierarchy.id}/`,
        title: hierarchy.title,
      })
      return acc
    }, [])
}

/**
 * 検索ページ用パンくずの階層を生成する
 */
export function resolveSearchHierarchies(
  stateHierarchies: Hierarchy[] | undefined,
  category: CategorySub | undefined,
  dictionary: CategoryDictionary
): Hierarchy[] {
  if (stateHierarchies) {
    return stateHierarchies
  }
  if (!category) {
    return []
  }

  return traverse(category, dictionary)
    .reverse()
    .reduce<Hierarchy[]>((acc, hierarchy) => {
      const prefix = acc.length > 0 ? acc[acc.length - 1].link.replace(/\/$/, '') : '/search'
      acc.push({
        link: `${prefix}/${hierarchy.id}/`,
        title: hierarchy.title,
      })
      return acc
    }, [])
}
